"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_2 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var widgets_1 = tslib_1.__importDefault(require("../../../view/widgets"));
var Header_1 = tslib_1.__importDefault(require("../../components/Header"));
var utilities_3 = require("../../utilities");
var FullRotation_1 = tslib_1.__importDefault(require("./FullRotation"));
var Grid_1 = tslib_1.__importDefault(require("./Grid"));
var List_1 = tslib_1.__importDefault(require("./List"));
var options_1 = require("./options");
var Slider_1 = tslib_1.__importDefault(require("./Slider"));
var Tiles_1 = tslib_1.__importDefault(require("./Tiles"));
var MOBILE_BREAKPOINT = 'xs';
var StyledSlider = styled_components_1["default"](Slider_1["default"])(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: block;\n  ", " {\n    display: none !important;\n  }\n"], ["\n  display: block;\n  ", " {\n    display: none !important;\n  }\n"])), utilities_1.mb(MOBILE_BREAKPOINT));
var StyledTiles = styled_components_1["default"](Tiles_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: none;\n  ", " {\n    display: grid;\n  }\n"], ["\n  display: none;\n  ", " {\n    display: grid;\n  }\n"])), utilities_1.mb(MOBILE_BREAKPOINT));
var ArticleList = function (_a) {
    var renderLink = _a.renderLink, renderEmpty = _a.renderEmpty, data = _a.data, _b = _a.data, _c = _b.header, header = _c === void 0 ? '' : _c, _d = _b.display, display = _d === void 0 ? options_1.ARTICLE_LIST_DISPLAY_DEFAULT_VALUE : _d, _e = _b.data, _f = _b.articleFilter, articleFilter = _f === void 0 ? [] : _f, _g = _b.imageAspectRatio, imageAspectRatio = _g === void 0 ? options_1.IMAGE_ASPECT_RATIO_DEFAULT_VALUE : _g, _h = _a.override, override = _h === void 0 ? {} : _h;
    var articles = utilities_2.getProp(data, ['data', 'articleFilter', 'articles'], []);
    if (!articles.length && renderEmpty) {
        return renderEmpty(data.type);
    }
    function render() {
        switch (display) {
            case options_1.ARTICLE_LIST_DISPLAY.FULL_ROTATION.value:
                return react_1["default"].createElement(FullRotation_1["default"], { items: articles, renderLink: renderLink });
            case options_1.ARTICLE_LIST_DISPLAY.TILES.value:
                return (react_1["default"].createElement(react_1["default"].Fragment, null,
                    react_1["default"].createElement(StyledSlider, { articles: articles, renderLink: renderLink }),
                    react_1["default"].createElement(StyledTiles, { articles: articles, renderLink: renderLink })));
            case options_1.ARTICLE_LIST_DISPLAY.LIST.value:
                return react_1["default"].createElement(List_1["default"], { articles: articles, renderLink: renderLink });
            case options_1.ARTICLE_LIST_DISPLAY.LIST_WITHOUT_PICTURES.value:
                return (react_1["default"].createElement(List_1["default"], { articles: articles, renderLink: renderLink, showPicture: false }));
            case options_1.ARTICLE_LIST_DISPLAY.CONTENT.value:
                return articles.map(function (a) { return (react_1["default"].createElement(react_1["default"].Fragment, { key: a._id },
                    react_1["default"].createElement(Header_1["default"], { renderShowmoreLink: function (linkProps) {
                            return renderLink({
                                type: utilities_3.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
                                payload: a,
                                linkProps: linkProps
                            });
                        } }, a.name),
                    react_1["default"].createElement(widgets_1["default"], { items: a.widgets || [], renderLink: renderLink, renderEmpty: renderEmpty, override: override }))); });
            case options_1.ARTICLE_LIST_DISPLAY.GRID.value:
                return (react_1["default"].createElement(Grid_1["default"], { articles: articles, renderLink: renderLink, imageAspectRatio: imageAspectRatio }));
            default:
                return null;
        }
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        header && (react_1["default"].createElement(Header_1["default"], { renderShowmoreLink: function (linkProps) {
                return renderLink({
                    type: utilities_3.WIDGET_LINK_TYPE.ARTICLE_FILTER,
                    payload: {
                        filter: articleFilter,
                        header: header
                    },
                    linkProps: linkProps
                });
            } }, header)),
        render()));
};
ArticleList.propTypes = {
    data: prop_types_1["default"].shape({
        header: prop_types_1["default"].string,
        display: prop_types_1["default"].oneOf(Object.values(options_1.ARTICLE_LIST_DISPLAY).map(function (d) { return d.value; })),
        imageAspectRatio: prop_types_1["default"].oneOf(Object.values(options_1.IMAGE_ASPECT_RATIO).map(function (d) { return d.value; })),
        articleFilter: prop_types_1["default"].array
    }),
    renderLink: prop_types_1["default"].func.isRequired,
    renderEmpty: prop_types_1["default"].func
};
ArticleList.defaultProps = {
    data: {}
};
exports["default"] = ArticleList;
var templateObject_1, templateObject_2;
